import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  unsavedQuoteState: null,
  aiChatHistory: [],
  isAiOpen: false,
  isAiEnabled: false,
};

const aiSlice = createSlice({
  name: 'ai',
  initialState,
  reducers: {
    setUnsavedQuoteState: (state, action) => {
      state.unsavedQuoteState = action.payload;
    },
    setAiChatHistory: (state, action) => {
      if (typeof action.payload === 'function') {
        state.aiChatHistory = action.payload(state.aiChatHistory);
      } else {
        state.aiChatHistory = action.payload || [];
      }
    },
    addAiChatMessage: (state, action) => {
      state.aiChatHistory.push(action.payload);
    },
    clearAiChatHistory: (state) => {
      state.aiChatHistory = [];
    },
    setIsAiOpen: (state, action) => {
      state.isAiOpen = Boolean(action.payload);
    },
    setIsAiEnabled: (state, action) => {
      state.isAiEnabled = Boolean(action.payload);
    },
    resetAiState: (state) => {
      state.unsavedQuoteState = null;
      state.aiChatHistory = [];
      state.isAiOpen = false;
    },
  },
});

export const {
  setUnsavedQuoteState,
  setAiChatHistory,
  addAiChatMessage,
  clearAiChatHistory,
  setIsAiOpen,
  setIsAiEnabled,
  resetAiState,
} = aiSlice.actions;

export default aiSlice.reducer;
